import { AwsRum, AwsRumConfig } from 'aws-rum-web';

let rumClient: AwsRum | null = null;

const createAwsRum = (config?: AwsRumConfig): AwsRum | null => {
  const {
    VITE_AWS_RUM_IDENTITY_POOL_ID: identityPoolId,
    VITE_AWS_RUM_RELEASE_ID: releaseId,
    VITE_AWS_RUM_APPLICATION_ID,
    VITE_AWS_RUM_APPLICATION_REGION,
    VITE_AWS_RUM_ENVIRONMENT
  } = import.meta.env;

  if (!VITE_AWS_RUM_APPLICATION_ID) {
    console.info(
      'AWS RUM is not initialized because APPLICATION ID is not configured.'
    );
    return null;
  }

  return new AwsRum(
    (VITE_AWS_RUM_APPLICATION_ID ?? '') as string,
    '0.0.0',
    (VITE_AWS_RUM_APPLICATION_REGION ?? '') as string,
    {
      sessionSampleRate: 1,
      identityPoolId: (identityPoolId ?? '') as string,
      telemetries: ['performance', 'errors', 'http'],
      allowCookies: false,
      enableXRay: true,
      releaseId: (releaseId as string | undefined) ?? undefined,
      sessionAttributes: {
        environment: (VITE_AWS_RUM_ENVIRONMENT ?? '') as string
      },
      ...config
    }
  );
};

export const getAwsRum = (): AwsRum | null => {
  return rumClient;
};

export const initializeAwsRum = () => {
  if (rumClient) {
    return;
  }
  try {
    rumClient = createAwsRum();
  } catch (err) {
    console.error('Error creating AWS RUM client.', err);
  }
};
